import React, { useContext, useEffect, useState } from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search, ColumnToggle } from 'react-bootstrap-table2-toolkit';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import { GetData } from "../Api";
import FilterContext from "../Hooks/Context";

const Grid = ({ gridData, gridColumns, name, searchData }) => {

  const filterQueries = useContext(FilterContext);
  const [reportData, SetReportData] = useState();
  const [isReportChanged, SetIsReportChanged] = useState();
  const [textSearch, SetTextSearch] = useState();

  const { ToggleList } = ColumnToggle;
  const columns = [
    { dataField: 'factory_name', text: 'Factory', sort: true, toggle: true },
    { dataField: 'line_id', text: 'Line', sort: true },
    { dataField: 'date', text: 'Date', sort: true },
    { dataField: 'shift', text: 'Shift', sort: true },
    { dataField: 'program_name', text: 'Process Name', sort: true, filter: textFilter() },
    { dataField: 'target_qty', text: 'Target Quantity', sort: true },
    { dataField: 'actual_qty', text: 'Actual Quantity', sort: true },
    { dataField: 'delivery', text: 'Delivery %', sort: true }
  ];

  const defaultSorted = [{
    dataField: 'name',
    order: 'desc'
  }];

  // useEffect(() => {
  //   SetTextSearch(props.searchData);
  // },[]);

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 20,
    lastPageText: '>>',
    firstPageText: '<<',
    nextPageText: '>',
    prePageText: '<',
    showTotal: true,
    alwaysShowAllBtns: false,
    onPageChange: function (page, sizePerPage) {
      console.log('page', page);
      console.log('sizePerPage', sizePerPage);
    },
    onSizePerPageChange: function (page, sizePerPage) {
      console.log('page', page);
      console.log('sizePerPage', sizePerPage);
    }
  });

  const { SearchBar, ClearSearchButton } = Search;

  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div className='report-icon-right'>
        <i className="fa fa-download download-icon" onClick={handleClick} aria-hidden="true"></i>
      </div>
    );
  };

  return (
    <div key={isReportChanged}>

      {gridData && <ToolkitProvider
        bootstrap4
        keyField='id'
        data={gridData}
        columns={gridColumns}
        search
        exportCSV={{
          fileName: `${name}.csv`
        }
        }
        columnToggle
      >
        {
          props => (
            <div>
              <MyExportCSV {...props.csvProps} />
              <BootstrapTable
                defaultSorted={defaultSorted}
                pagination={pagination}
                {...props.baseProps}
                filter={filterFactory()}
              />
            </div>
          )
        }
      </ToolkitProvider>}
    </div>
  );
};

export default Grid;
